import { useMemo } from "react";
import { useLocalStorage } from "react-use";
import { AuthContext } from "@/contexts";
import { LoginRequest, AuthService } from "@/domains/auth";
import { UserPermission, UserRead } from "@/domains/user";
import { UserCategory } from "@/domains/user";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser, removeUser] = useLocalStorage<UserRead>(
    "user",
    {} as never
  );

  const [token, setToken, removeToken] = useLocalStorage<string>("token", "", {
    raw: true,
  });

  const isLoggedIn = useMemo(() => !!user && !!token, [user, token]);

  const isOperator =
    user &&
    [UserCategory.OperatorAccount, UserCategory.OperatorSubAccount].includes(
      user.category
    );

  const login = async (payload: LoginRequest) => {
    const res = await AuthService.login(payload).run();
    setUser(res.data.msg.user);
    setToken(res.data.msg.token);
  };

  const logout = () => {
    removeUser();
    removeToken();
  };

  const hasPerm = (perm: UserPermission) => {
    return !!user?.permissions.includes(perm);
  };

  return (
    <AuthContext.Provider
      value={{ user, token, isLoggedIn, isOperator, login, logout, hasPerm }}
    >
      {children}
    </AuthContext.Provider>
  );
};
